export const USER = {
  SIGNUP: 'Sign Up',
  LOGIN: 'Login',
  SETTINGS: 'Settings',
  USER_DELETED: 'User has been deleted.',
  FORGOT_PASSWORD_TEXT: 'Enter the email used to signup with us.',
  RESET_PASSWORD_TEXT: 'Enter your new password below.',
  MEMBER_SINCE: 'Member Since: ',
  DASHBOARD: 'Dashboard',
  CORE_USER: [
    'newUser',
    'interests',
    'avatar',
    'bio',
    'companyName',
    'country',
    'zipPostalCode',
    'email',
    'firstName',
    'jobTitle',
    'lastName',
    'phoneNumber',
    'username',
    'password',
    'passwordConfirm',
    'role',
  ],
  DELETE_ACCOUNT_CONFIRM: 'Are you sure you want to delete your account?',
  DELETE_ACCOUNT_BODY:
    'You will not be able to revert this action once you delete your account. Remember to download your data before proceeding to delete your account.',
  DELETE_ACCOUNT_CLOSE_DIALOG: `No I don't want to close my Account`,
  DELETE_ACCOUNT: 'Delete Account',
  TAB_LABELS: {
    PROFILE: 'Profile',
    PREFERENCES: 'Preferences',
    BIO: 'Bio',
    ACCOUNT: 'Account',
    DEVICES: 'Devices',
    INTEGRATIONS: 'Integrations',
    BILLING: 'Billing',
    PROFESSIONAL_BACKGROUND: 'Professional Background',
  },
  PREFERENCES: ['theme', 'landingPage', 'avatar'],
};
